import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/audit-logs')({
  beforeLoad: () => {
    throw redirect({ to: '/activity' })
  },
})
